import React from 'react';
import { Box, Typography, Paper, TextField, Tooltip, Button, IconButton } from '@mui/material';
import styles from './LibraryItemDetailsBlock.module.scss';
import { useTranslation } from 'react-i18next';
import { LibraryItemDetailsBlockProps } from './types';
import ButtonDropDown from '../../../../common/button-drop-down/ButtonDropDown';
import InfoIcon from '@mui/icons-material/Info';
import BrushIcon from '../../../../../assets/svg/brush.svg?react';

const LibraryItemDetailsBlock = ({
  workflowsArray,
  typeLabels,
  propertiesEditMode,
  documentTypeLabel,
  setDocumentTypeLabel,
  documentWorkflowLabel,
  setDocumentWorkflowLabel,
  templateName,
  setTemplateName,
  category,
  setCategory,
  customLabel,
  setCustomLabel,
  categoryArray,
  setPropertiesEditMode,
  updateLibraryItem,
}: LibraryItemDetailsBlockProps) => {
  const { t } = useTranslation();
  return (
    <>
      <Box className={styles.container}>
        <Box className={styles.sectionHeader}>
          <Typography variant='h6' className={styles.sectionTitle}>
            {t('headers.properties')}
          </Typography>
          {propertiesEditMode ? (
            <Button
              type='button'
              className='btn-default btn-action-basic'
              role='button'
              variant='contained'
              onClick={() => {
                updateLibraryItem();
                setPropertiesEditMode(false);
              }}
            >
              {t('buttons.save')}
            </Button>
          ) : (
            <Tooltip title={t('buttons.edit')} placement='top' arrow>
              <IconButton
                size='small'
                className={styles.editButton}
                onClick={() => setPropertiesEditMode(true)}
              >
                <BrushIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
        <Paper className={styles.propertiesContainer} elevation={0}>
          <Box className={styles.propertyItem}>
            <TextField
              fullWidth
              label={t('labels.templateName')}
              variant='outlined'
              size='medium'
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              disabled={!propertiesEditMode}
            />
          </Box>
          <Box className={styles.inputs_container}>
            <Box className={styles.propertyItem}>
              <ButtonDropDown
                label={t('labels.profile')}
                options={categoryArray}
                disabled={!propertiesEditMode}
                onChange={(event) => {
                  setCategory(event.target.value);
                  setDocumentWorkflowLabel('');
                }}
                value={category}
              />
            </Box>
            <Box className={styles.propertyItem}>
              <ButtonDropDown
                label={t('labels.documentWorkflow')}
                options={workflowsArray}
                disabled={!propertiesEditMode}
                onChange={(event) => setDocumentWorkflowLabel(event.target.value)}
                value={documentWorkflowLabel}
              />
            </Box>
            <Box className={styles.propertyItem}>
              <ButtonDropDown
                label={t('labels.documentType')}
                options={typeLabels}
                disabled={!propertiesEditMode}
                onChange={(event) => setDocumentTypeLabel(event.target.value)}
                value={documentTypeLabel}
              />
            </Box>
            <Box className={styles.propertyItem}>
              <TextField
                fullWidth
                label={t('labels.customLabel')}
                variant='outlined'
                size='medium'
                autoComplete='off'
                value={customLabel}
                onChange={(event) => setCustomLabel(event.target.value)}
                disabled={!propertiesEditMode}
                InputProps={{
                  endAdornment: (
                    <Box component='div' sx={{ display: 'flex', alignItems: 'center' }}>
                      <Tooltip title={t('messages.customLabelMessage')} arrow placement='top'>
                        <InfoIcon fontSize='small' color='primary' />
                      </Tooltip>
                    </Box>
                  ),
                }}
              />
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default LibraryItemDetailsBlock;
